import type {
  Activity,
  ActivityType,
  AcknowledgementPayloadDTO,
  AcknowledgementResponseDTO,
  ConsentPayloadDTO,
  ConsentResponseDTO,
  PatientProfile,
  ProfileUpdatePayload,
  UUID,
} from "@/core/types";
import type { ApiContext } from "@/api/types";
import { httpAuth2 } from "@/api/auth";
import type { InsuranceListResponse } from "@/features/insurance/types";

export const patientRequestsTyped = {
  append_acknowledgement: function ({
    context,
    data,
  }: {
    context?: ApiContext;
    data: AcknowledgementPayloadDTO;
  }) {
    return httpAuth2
      .post("/v1/patient/append_acknowledgement", { context, json: data })
      .json<AcknowledgementResponseDTO>();
  },

  append_patient_consent: function ({
    context,
    data,
  }: {
    context?: ApiContext;
    data: ConsentPayloadDTO;
  }) {
    return httpAuth2
      .post("/v1/patient/append_consent", {
        context: { preventAllErrorToast: true, ...context },
        json: data,
      })
      .json<ConsentResponseDTO>();
  },

  fetch_profile: function ({ context }: { context?: ApiContext } = {}) {
    return httpAuth2.post("/v1/patient/profile", { context }).json<{ user: PatientProfile }>();
  },

  get_activity_list: function ({ context, type }: { context?: ApiContext; type: ActivityType }) {
    return httpAuth2
      .post("/v1/patient/activity", { context, searchParams: { type } })
      .json<Activity[]>();
  },

  // intentionally authenticated — post-login counterpart to fetch_insurance_list in patient.js
  // (same endpoint, different auth level by design)
  get_insurance_list: function ({ context }: { context?: ApiContext } = {}) {
    return httpAuth2.post("/v2/patient/insurance", { context }).json<InsuranceListResponse>();
  },

  remove_from_wait_list: function ({
    context,
    patientId,
  }: {
    context?: ApiContext;
    patientId: UUID;
  }) {
    return httpAuth2
      .post("/v1/patient/wait_list", {
        context,
        searchParams: { method: "remove", patient_username: patientId },
      })
      .json<void>();
  },

  update_profile: function ({
    context,
    data,
  }: {
    context?: ApiContext;
    data: ProfileUpdatePayload;
  }) {
    return httpAuth2
      .post("/v1/patient/update_profile", { context, json: data })
      .json<PatientProfile>();
  },
};
